import { render } from "./show.vue?vue&type=template&id=20a30f30"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__